import MediaPlayer from "../MediaPlayer";
import m, {Vnode} from "mithril";

export default class PlayPause {
    constructor(
        public readonly player: MediaPlayer
    ) { }

    public view(): Vnode {
        const isPlaying = this.player.isPlaying();
        return m(
            'div.control.control-main'+(isPlaying?'.playing':'.paused'),
            {
                    onclick: () => this.player.playPause(),
                },
            isPlaying ? m('i.icon.icon-pause.text-gray') : m('i.icon.icon-play.text-light')
        );
    }
}